export class Position {
  x: number | undefined;
  y: number | undefined;

    constructor(x: number | undefined, y: number | undefined) {
    this.x = x;
    this.y = y;
  }
}
